import React, {useContext} from 'react'

export type ReportsModalContextProps = {
  id: string
  prefix: string
  extended: boolean
  setExtended: (extended: boolean) => void
}

const ReportsModalContext = React.createContext<ReportsModalContextProps>(null as any)

export default ReportsModalContext

export function useReportsModalContext() {
  return useContext(ReportsModalContext)
}
